import executeScript from "../../hooks/executeScript";

const CallScript = (props) => {
  executeScript(props.urlString, props.asyncBoolean, props.innerScriptString);
  return null;
};

export default CallScript;